package one.devsbox.www.ui.locations.detail

import androidx.compose.animation.Crossfade
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.DeleteOutline
import compose.assets.svg.DeviceOutline
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.tools.ArgsId
import one.devsbox.www.ui.locations.LocationDetails
import one.devsbox.www.ui.widgets.*
import one.devsbox.www.www_portal.generated.resources.*
import org.jetbrains.compose.resources.stringResource
import tk.mallumo.compose.navigation.ComposableNavNode
import tk.mallumo.utils.DataState

@Composable
@ComposableNavNode(ArgsId::class)
fun LocationDUI() {
    with(LocationDCtx.get()) {
        ContentLocationUI()
    }
}

@Composable
context(ctx: LocationDCtx)
private fun ContentLocationUI() {
    Column(modifier = Modifier.fillMaxSize().padding(16.dp)) {
        Crossfade(targetState = ctx.vm.state) { state ->
            when (state) {
                is DataState.Idle -> Unit
                is DataState.Loading -> FullscreenLoadingUI()
                is DataState.Error -> {
                    FullscreenErrorUI(
                        message = state.message,
                        onBack = { ctx.action.back() },
                        onReload = { ctx.action.reload() }
                    )
                }

                is DataState.Result -> Box(modifier = Modifier.fillMaxSize()) {
                    Column {
                        ContentDefinition(state.nnvl)
                    }
                    ContentActions(
                        contentActions = ctx.vm.contentActions,
                        colorInactive = ctx.colorSecondaryContainer,
                        colorActive = ctx.colorPrimaryContainer
                    )
                }
            }
        }
    }

    if (ctx.vm.showDeleteConfirmation) {
        AlertDialog(
            onDismissRequest = { ctx.action.dismissDeleteConfirmation() },
            title = { Text(stringResource(Res.string.ui_locations_detail_delete_confirm_title)) },
            text = { Text(stringResource(Res.string.ui_locations_detail_delete_confirm_message)) },
            confirmButton = {
                TextButton(
                    onClick = {
                        ctx.action.confirmDelete()
                    }
                ) {
                    Text(
                        text = stringResource(Res.string.ui_locations_detail_btn_delete),
                        color = MaterialTheme.colorScheme.error
                    )
                }
            },
            dismissButton = {
                TextButton(onClick = { ctx.action.dismissDeleteConfirmation() }) {
                    Text(stringResource(Res.string.ui_devices_edit_deviceeui_cancel))
                }
            }
        )
    }

    if (ctx.vm.showDeleteError) {
        AlertDialog(
            onDismissRequest = { ctx.action.dismissDeleteError() },
            title = { Text(stringResource(Res.string.ui_devices_edit_deviceeui_error)) },
            text = { Text(stringResource(Res.string.ui_locations_detail_delete_failed)) },
            confirmButton = {
                TextButton(onClick = { ctx.action.dismissDeleteError() }) {
                    Text(stringResource(Res.string.ui_devices_edit_deviceeui_ok))
                }
            }
        )
    }
}

context(ctx: LocationDCtx) @Composable
private fun ContentDefinition(data: LocationDVM.Data) {
    SearchBox(
        state = ctx.vm.search,
        modifier = Modifier.fillMaxWidth(),
        hint = stringResource(Res.string.ui_locations_detail_search_hint, data.location.name)
    )
    Spacer(Modifier.size(16.dp))
    LocationDetails(data.location)

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier.padding(vertical = 16.dp)
    ) {
        Text(
            stringResource(Res.string.devices).uppercase(),
            style = MaterialTheme.typography.headlineSmall,
            fontWeight = FontWeight.Bold
        )
        Spacer(Modifier.width(8.dp))
        Surface(
            color = MaterialTheme.colorScheme.surfaceVariant,
            shape = RoundedCornerShape(4.dp)
        ) {
            Text(
                stringResource(
                    Res.string.ui_locations_detail_devices_count,
                    data.location.devices.size
                ),
                modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp)
                    .align(Alignment.Bottom),
                style = MaterialTheme.typography.labelMedium
            )
        }
        if (!data.location.devices.isEmpty()) {
            Spacer(Modifier.weight(1F))

            EntryViewSwitch(ctx.prefs.deviceLayoutType) {
                ctx.prefs.deviceLayoutType = it
            }
        }
    }

    if (data.location.devices.isEmpty()) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 48.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Icon(
                imageVector = Svg.DeviceOutline,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.4f),
                modifier = Modifier.size(48.dp)
            )
            Spacer(modifier = Modifier.height(16.dp))
            Text(
                text = stringResource(Res.string.string_ui_locations_detail_devices_empty),
                style = MaterialTheme.typography.bodyLarge,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                textAlign = TextAlign.Center
            )
        }
    } else {
        DevicesListing(
            devices = data.location.devices,
            search = ctx.vm.search,
            enabled = ctx.me.permission.device.read
        ) {
            ctx.action.openDetail(it.id)
        }
    }
}



